import request from './request';
import deserialize from './deserialize';

type Image = {
  id: string;
  versions: {
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
};

export type Company = {
  id: string;
  name: string;
  category: {
    key: string;
    label: string;
  };
  about: string;
  url: string;
  logo?: Image;
  cover?: Image;
  applink: string;
  country: string;
  phone: string;
  maxNumStores: number;
};

export function get(id: string) {
  return request<Company>({
    url: `/companion/v1/companies/${id}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
